import { render, staticRenderFns } from "./SubTotal.vue?vue&type=template&id=686d5a36&"
import script from "./SubTotal.vue?vue&type=script&lang=js&"
export * from "./SubTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports